import React from "react";
import MenuEscritorio from "./componenteshome/MenuEscritorio";
import FooterMenu from "./componenteshome/footer";
import EditarAventura from "./crearaventura/editar-aventura";

export default function ModificarAventura() {
  return (
    <div>
      <EditarAventura />
      <MenuEscritorio />
      <FooterMenu />
    </div>
  );
}
